import React, { useEffect, useState, useCallback} from "react";
import { useSelector, useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { CardNumberElement } from "@stripe/react-stripe-js";
import { useStripe } from "@stripe/react-stripe-js";
import { useElements } from "@stripe/react-stripe-js";
import { fetchFromAPI } from "./helpers";
import { getReceiver, getFurigana, getTelephone, getPostCode, getPrefecture, getCity, getAddress, getApartmentAndRoom } from "../reducks/shippingInfo/selectors";
import { getBookTitle, getAuthor, getBookCover, getPurchaser, getPurchaserFurigana, getEmail, getNoteUrl,getIdentification, getBirthOfDay, getSex, getHowDidChermoKnow, getOtherSpecificContent, getCopyright } from "../reducks/orders/selectors";
import { TrSpace } from "../components/TrSpace";
import { TrCardNumberElement } from "./TrCardNumberElement";
import { TrCardExpiryElement } from "./TrCardExpiryElement";
import { TrCardCvcElement } from "./TrCardCvcElement";
import { TrText } from "../components/TrText";
import { registerOrders } from "../reducks/orders/operations";
import { registerShippingInfo } from "../reducks/shippingInfo/operations";
import { registerOrderStatus } from "../reducks/orderStatus/operations";
import { sendEmail } from "../email/send-email";

export const CustomCheckout = () => {
    const dispatch = useDispatch();
    const selector = useSelector(state => state);
    const stripe = useStripe();
    const elements = useElements();

    const [clientSecret, setClientSecret] = useState(null);
    const [processing, setProcessing] = useState(false);
    const [error, setError] = useState(null);

    // shippingInfo stateを取得
    const receiver = getReceiver(selector)
    const furigana = getFurigana(selector)
    const telephone = getTelephone(selector)
    const postCode = getPostCode(selector)
    const prefecture = getPrefecture(selector)
    const city = getCity(selector)
    const address = getAddress(selector)
    const apartmentAndRoom = getApartmentAndRoom(selector)

    // ordersのstateを取得
    const bookTitle = getBookTitle(selector)
    const author = getAuthor(selector)
    const bookCover = getBookCover(selector)
    const purchaser = getPurchaser(selector)
    const purchaserFurigana = getPurchaserFurigana(selector)
    const email = getEmail(selector);
    const noteUrl = getNoteUrl(selector)
    const identification = getIdentification(selector)
    const copyright = getCopyright(selector)
    const birthOfDay = getBirthOfDay(selector)
    const sex = getSex(selector);
    const howDidChermoKnow = getHowDidChermoKnow(selector);
    const otherSpecificContent = getOtherSpecificContent(selector);
    
    
    const orderuuid = (() => {
        var strong = 1000;
        return new Date().getTime().toString(16)  + Math.floor(strong*Math.random()).toString(16)
    })()


    const ordersValidate = (() => {
        if ( bookTitle === "" || author === "" || purchaser === "" || purchaserFurigana === "" 
            || email === "" || noteUrl.length === 0 || (!identification && !copyright) ) {
            return true
        } else {
            return false
        }
    })()


    const shippingInfoValidate = (() => {
        if (receiver === "" || furigana === "" || telephone === "" || postCode === "" 
            || prefecture === "" || city === "" || address === "") {
            return true
        } else {
            return false
        }
    })()


    const sendEmailParams = {
        to_email: email,
        to_name: purchaser,
        author: author,
        title: bookTitle,
        book_cover: bookCover,
        receiver: receiver,
        furigana: furigana,
        post_code: postCode,
        address: prefecture + city + address + apartmentAndRoom,
        telephone: telephone,
        price: "700"
    }

    noteUrl.forEach((url, index) => {
        sendEmailParams[`url${index+1}`] = url;
    });

    useEffect( () => {
        const items = [{ price: 700, quantity: 1 }] // price：chermoの値段、quantity：注文冊数
        const shippingName = receiver; // 配送先の受取人の名前
        const shippingAdress = prefecture + city + address + apartmentAndRoom; // 配送先住所
        const purchaserEmail = email;

        const body = {
            cartItems: items,
            shipping: {
                name: shippingName,
                address: {
                    line1: shippingAdress
                }
            },
            description: "payment intent for Chermo",
            receipt_email: purchaserEmail
        }

        const customCheckout = async () => {
            const {clientSecret} = await fetchFromAPI('create-payment-intent', {
                body
            });

            setClientSecret(clientSecret);
        }

        customCheckout();
    }); // TODO: ここは依存する変数や関数を入れるerrorがでるはずなのでfixする

    const handleCheckout = async () => {
        setProcessing(true);

        /*
            Stripe.confirmCardPayment(clientSecret: string, data?: ConfirmCardPaymentData, options?: ConfirmCardPaymentOptions): Promise<PaymentIntentResult>
            メソッド内容：顧客が支払いフォームを送信するときに使用
            引数（型）
            - clientSecret（string）：クライアント側のsecret key
            - data：request時に送信されるdata

            返り値
            - Promise<PaymentIntentResult>
                - 成功時：result.paymentIntent
                - 失敗時：result.error

            詳細は以下のURLを参照
            https://stripe.com/docs/js/payment_intents/confirm_card_payment#stripe_confirm_card_payment-clientSecret
        */
        // payloadにカードの支払いの結果を取得
        const payload = await stripe.confirmCardPayment(clientSecret, {
            payment_method: {
                card: elements.getElement(CardNumberElement)
            }
        });

        // カードに支払いが成功か失敗かを判定
        if (payload.error) {
            // カードでの支払いに失敗した場合は、エラーメッセージをセット
            setError(`Payment Failed: ${payload.error.message}`)
        } else {
            // 支払い完了ページに遷移
            dispatch(push('/order-completed'));
        }
    }

    // カード情報の入力の変更を検知するメソッド
    const cardHandleChange = useCallback((event) => {
        const { error } = event;
        setError(error ? error.message : '');
    }, [setError]);

    return (
        <div className='flex flex-col min-h-screen'>
        <main className="flex-grow">
            <div className="pl-4 lg:pl-16 text-xl lg:text-2xl iPad/iPadMini:w-full lg:w-9/12 font-serif border-b border-black" style={{letterSpacing: '5px'}}>クレジットカード情報を入力</div>
            <div className="grid justify-items-center pt-16 pb-16">
            <table className="iPad/iPadMini:w-11/12 md:w-6/12">
                <tbody>
                    <TrText text="カード番号"/>
                    <TrCardNumberElement
                        onChange={cardHandleChange}
                    />
                    <TrSpace />
                    <TrText text="有効期限"/>
                    <TrCardExpiryElement
                        onChange={cardHandleChange}
                    />
                    <TrSpace />
                    <TrText text="セキュリティコード"/>
                    <TrCardCvcElement
                        onChange={cardHandleChange}
                    />
                    <TrSpace />
                </tbody>
            </table>
                <div>
                    <button
                        disabled={processing}
                        className="iPhone5/SE:w-72 w-80 h-16 text-black bg-white font-serif border border-black hover:bg-black hover:text-white"
                        onClick={async () => {
                            if ( (!ordersValidate) && (!shippingInfoValidate) ) {
                                dispatch(registerOrders(bookTitle, author, bookCover, purchaser, purchaserFurigana, email, noteUrl, identification, copyright, orderuuid, birthOfDay, sex, howDidChermoKnow, otherSpecificContent));
                                dispatch(registerShippingInfo(receiver, furigana, telephone, postCode, prefecture, city, address, apartmentAndRoom, orderuuid));
                                dispatch(registerOrderStatus(orderuuid));
                                await handleCheckout();
                                sendEmail(sendEmailParams);
                                dispatch(push('/order-completed'))
                            } else {
                                dispatch(push('/order-failed'))
                            }
                        }}
                    >
                    {
                        // processingによって、ボタンの文字を変更
                        processing ? "支払い処理中" : "注文する"
                    }
                    </button>
                </div>
                {
                    // errorが発生している場合、エラーメッセージを表示
                    error && (<p className="">{error}</p>)
                }
            </div>
        </main>
        </div>
    );
}